<section class="product-expert" id="expertOpinions">
  <h3 class="product-expert__title">
    {{ 'global.expert_opinions' | translate }}
  </h3>

  <!-- product descriptions -->
  <div class="product-expert__content">
    <div class="expert-description">
      <p class="expert-description__text">
        {{ 'home.expertHint' | translate }}
      </p>
    </div>
  </div>

  <!-- expert opinion -->
  @if (expertOpinionsData()?.specialist_note) {
    <div class="product-expert__opinion">
      <!-- opinion content -->
      <div class="opinion-profile">
        <img
          [ngSrc]="
            expertOpinionsData().specialist_person?.profile_image?.cropped_url?.toLowerCase() ||
              expertOpinionsData().specialist_person?.profile_image?.url
              | imageSource
          "
          width="64"
          height="64"
          class="opinion-profile__img" />
        <div class="opinion-profile__info">
          <h4 class="profile-name">
            {{ expertOpinionsData()?.specialist_person?.first_name }}
            {{ expertOpinionsData()?.specialist_person?.last_name }}
          </h4>
          <p class="profile-role">
            {{
              expertOpinionsData()?.specialist_person?.job_position
                | translateData
            }}

            {{ expertOpinionsData()?.business_title | translateData }}
          </p>
        </div>
      </div>

      <div class="opinion-comment">
        <p class="opinion-comment__text">
          {{ expertOpinionsData()?.specialist_note | translateData }}
        </p>
        <img
          class="opinion-comment__quote"
          ngSrc="assets/images/quote.svg"
          width="58"
          height="49"
          alt="quote" />
      </div>
    </div>
  }

  <!-- expert media -->
  <div class="product-expert__media">
    @if (expertOpinionsData()?.specialist_video?.[0]) {
      <!-- expert video -->
      <div class="expert-video">
        <h3 class="expert-video__title">
          {{ 'global.video_Expert' | translate }}
        </h3>
        <div class="expert-video__container">
          <pwj-video-player
            btnsClass="!mt-0"
            playBtnText="products.videoExpert"
            [videoPreviewSrc]="
              expertOpinionsData()?.specialist_video?.[0]?.url | imageSource
            "></pwj-video-player>
        </div>
      </div>
    }
    <!-- expert gallery -->
    @if (expertOpinionsData()?.specialist_photos?.[0]) {
      <div class="expert-gallery">
        <h3 class="expert-gallery__title">
          {{ 'global.galery_Expert' | translate }}
        </h3>
        <div class="expert-gallery__image">
          <!-- media gallery -->
          <pwj-gallery
            [mediaData]="expertOpinionsData()?.specialist_photos || []"
            [mediaListCount]="2"
            [isColumnListMode]="true"
            previewWidth="534"
            previewHeight="312"
            previewWidthClass="!w-534"
            previewHeightClass="!h-312"
            [previewAlt]="
              (expertOpinionsData()?.business_title | translateData) || ''
            "></pwj-gallery>
        </div>
      </div>
    }
  </div>
</section>
